// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"81":"2d723da2","226":"28c16a3b","394":"2d723da2","596":"f1b3171d","768":"7957f39f","994":"4355f689"}[chunkId] + ".chunk.css";
};